<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import vClickOutside from "v-click-outside";

export default {
    page: {
        title: "Faculties",
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    components: {
        Layout,
        PageHeader,
        Multiselect,
    },
    data() {
        return {
            title: "Faculties",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Faculties",
                    active: true,
                },
            ],
            tableData: [],
            campuses: [],
            dus: [],
            available: [],
            engagements: [
                {
                    id: 1,
                    value: "A",
                    name: "Pursuing advanced research degree program (Ph.D.)",
                    valueName: 'A - Pursuing advanced research degree program (Ph.D.)',
                },
                {
                    id: 2,
                    value: "B",
                    name: "Actively pursuing research 1 withing the last (3) years",
                    valueName: 'B - Actively pursuing research 1 withing the last (3) years',
                },
                {
                    id: 3,
                    value: "C",
                    name: "Producing technologies for commercialization or livelihood improvement",
                    valueName: 'C - Producing technologies for commercialization or livelihood improvement',
                },
                {
                    id: 4,
                    value: "D",
                    name: "Research work resulted in an extension program",
                    valueName: 'D - Research work resulted in an extension program',
                },
                {
                    id: 5,
                    value: "E",
                    name: "None of the above",
                    valueName: 'E - None of the above',
                },
            ],
            fields: [
                {
                    key: "faculty",
                    sortable: true,
                    label: "Faculty",
                },
                {
                    key: "designation",
                    sortable: true,
                    label: "Designation",
                },
                {
                    key: "engagement",
                    sortable: true,
                    label: 'Faculty Engagement'
                },
                {
                    key: "actions",
                    thStyle: { width: "100px" },
                },
            ],
            form: {
                id: 0,
                deliveryUnitId: null,
                idNumbers: null
            },
            engagement: null,
            campus: null,
            faculty: [],
            deliveryUnit: null,
            indexSelected: null,
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            sortDesc: false,
            tableBusy: false,
            filter: null,
            filterOn: ["fullName"],
            sortBy: "",
            modalTitle: "",
            showFilter: false,
            campusSelect: this.$store.state.data.campus.id,
            duSelect: null,
            openFaculty: false,
            facultySelection: false,
            filterFaculty: "",
            selectedFaculty: [],
            facultyLoading: false,
            duLoading: false,
        };
    },
    validations: {
        form: {
            deliveryUnitId: {
                required,
            },
        },
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.tableData.length;
        },
        filteredFaculties(){
            let data = this.available;
            if (this.filterFaculty.trim() != "" && this.filterFaculty) {
                data = data.filter((item) => {
                    return item.fullName
                        .toUpperCase()
                        .includes(this.filterFaculty.toUpperCase());
                });
            }
            return data;
        }
    },
    async created() {
        this.pageLoader(true);
        // await this.getFaculties();
        await this.getCampuses();
        await this.getAvailableFaculties();
        await this.filteredDU(this.$store.state.data.campus.id);
        this.duSelect = this.$store.state.data.deliveryUnit.id;
        await this.searchFaculty(this.$store.state.data.deliveryUnit.id);
        this.pageLoader(false);
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async getAvailableFaculties() {
            await this.$store
                .dispatch("faculty/GetAvailableFaculties")
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.middleName ? item.middleName : "";
                        item.fullName =
                            item.lastName +
                            ", " +
                            item.firstName +
                            " " +
                            middleName;
                    });
                    this.available = response.data;
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting available faculties",
                        "error"
                    );
                });
        },
        async getFaculties() {
            await this.$store
                .dispatch("faculty/GetFaculties")
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.accountableOfficer.middleName
                            ? item.accountableOfficer.middleName
                            : "";
                        item.fullName =
                            item.accountableOfficer.lastName +
                            ", " +
                            item.accountableOfficer.firstName +
                            " " +
                            middleName;
                        let findEngagement = this.engagements.find(
                            (x) => x.value === item.facultyEngagement
                        );
                        item.engagement = findEngagement ? findEngagement.name : '';
                    });
                    this.tableData = response.data;
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting faculties",
                        "error"
                    );
                });
        },
        async getCampuses() {
            let data = this.$store.state.decrypt.campusAccessList();
            data.forEach((item) => {
                item.noSpaces = item.CampusName.replace(/\s/g, "");
            });
            this.campuses = data;
        },
        async searchDU(item) {
            this.dus = [];
            this.form.deliveryUnitId = "";
            this.deliveryUnit = null;
            this.duLoading = true;
            await this.$store
                .dispatch("deliveryunit/GetDeliveryUnitByCampus", item.Id)
                .then((response) => {
                    response.data.forEach((item) => {
                        item.newName = item.name.trim();
                    });
                    this.dus = response.data;
                    this.dus.sort(function(a, b){
                        if(a.newName < b.newName) { return -1; }
                        if(a.newName > b.newName) { return 1; }
                        return 0;
                    })
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting delivery units",
                        "error"
                    );
                });
            this.duLoading = false;
        },
        selectDU(item) {
            this.form.deliveryUnitId = item.id;
        },
        selectEngagement(item) {
            this.form.facultyEngagement = item.value;
        },
        onReset() {
            this.form = {
                id: 0,
                deliveryUnitId: "",
                idNumbers: [],
            };
            this.campus = null;
            this.selectedFaculty = [];
            this.deliveryUnit = null;
            this.$v.form.$reset();
        },
        addFaculty() {
            this.onReset();
            this.modalTitle = "Create New Faculty";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            if (this.form.id > 0) {
                this.$store
                    .dispatch("faculty/UpdateFaculty", this.form)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        res.data.deliveryUnit = this.dus.find(
                            (x) => x.id == this.form.deliveryUnitId
                        );
                        let middleName = res.data.accountableOfficer.middleName
                            ? res.data.accountableOfficer.middleName
                            : "";
                        res.data.fullName =
                            res.data.accountableOfficer.lastName +
                            ", " +
                            res.data.accountableOfficer.firstName +
                            " " +
                            middleName;
                        this.tableData.splice(this.indexSelected, 1, res.data);
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                if(this.selectedFaculty.length == 0){
                    return this.showToast("Please select at least one faculty", "warning");
                }
                let data = {
                    deliveryUnitId: this.form.deliveryUnitId,
                    idNumbers: [],
                }
                this.selectedFaculty.forEach((item) => {
                    data.idNumbers.push(item.idNo);
                });
                this.$store
                    .dispatch("faculty/AddMultipleFaculty", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.getFaculties();
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        async updateItem(props) {
            this.indexSelected = this.tableData.indexOf(props.item);
            console.log(props.item);
            this.campus = {
                Id: props.item.deliveryUnit.office.campus.id,
                CampusName: props.item.deliveryUnit.office.campus.campusName,
                ShortName: props.item.deliveryUnit.office.campus.shortName,
                noSpaces: props.item.deliveryUnit.office.campus.campusName.replace(/\s/g, ""),
            }
            await this.searchDU(this.campus);
            this.deliveryUnit = this.dus.find(
                (x) => x.id == props.item.deliveryUnitId
            );
            this.form = cloneDeep(props.item);
            this.modalTitle = "Update Faculty";
            this.$bvModal.show("modal-standard");
        },
        deleteItem(props) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    let index = this.tableData.indexOf(props.item);
                    this.$store
                        .dispatch("faculty/DeleteFaculty", props.item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async filteredDU(id) {
            this.dus = [];
            this.duSelect = {};
            if(id == 0){
                this.tableBusy = true;
                await this.$store
                    .dispatch("faculty/GetAllFaculties")
                    .then((response) => {
                        response.data.forEach((item) => {
                            let middleName = item.accountableOfficer.middleName
                                ? item.accountableOfficer.middleName
                                : "";
                            item.fullName =
                                item.accountableOfficer.lastName +
                                ", " +
                                item.accountableOfficer.firstName +
                                " " +
                                middleName;
                            let findEngagement = this.engagements.find(
                                (x) => x.value === item.facultyEngagement
                            );
                            item.engagement = findEngagement ? findEngagement.name : '';
                        });
                        this.tableData = response.data;
                    })
                    .catch((error) => {
                        this.showToast(
                            "Something went wrong - getting delivery units",
                            "error"
                        );
                    });
                this.tableBusy = false;
            }else{
                await this.$store
                .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
                .then((response) => {
                    response.data.forEach(item => {
                        item.newName = item.name.trim();
                    });
                    this.dus = response.data;
                    this.dus.sort(function(a, b){
                        if(a.newName < b.newName) { return -1; }
                        if(a.newName > b.newName) { return 1; }
                        return 0;
                    })
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting delivery units",
                        "error"
                    );
                });
            }
        },
        async searchFaculty(id) {
            this.tableBusy = true;
            await this.$store
                .dispatch("faculty/GetFacultyByDU", id)
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.accountableOfficer.middleName
                            ? item.accountableOfficer.middleName
                            : "";
                        item.fullName =
                            item.accountableOfficer.lastName +
                            ", " +
                            item.accountableOfficer.firstName +
                            " " +
                            middleName;
                        let findEngagement = this.engagements.find(
                            (x) => x.value === item.facultyEngagement
                        );
                        item.engagement = findEngagement ? findEngagement.name : '';
                    });
                    this.tableData = response.data;
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting delivery units",
                        "error"
                    );
                });
            this.tableBusy = false;
        },
        openFacultySelection() {
            this.facultySelection = true;
            this.openFaculty = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.inputFaculty.focus();
                }, 500);
            });
        },
        closeFaculty() {
            if (this.facultySelection) {
                this.facultySelection = false;
            }
            this.openFaculty = false;
        },
        selectFacultyFL(row){
            this.selectedFaculty.push(row);
            this.available.splice(this.available.indexOf(row), 1);
            let index = this.campuses.findIndex(
                (x) => x.noSpaces === row.campus.replace(/\s/g, "")
            );
            this.campus = this.campuses[index];
            this.filterFaculty = '';
            this.$refs.inputFaculty.focus();
        },
        removeFaculty(index){
            this.available.unshift(this.selectedFaculty[index]);
            this.selectedFaculty.splice(index, 1);
        },
        selectCampus(item){
            this.searchDU(item);
        }
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="modal-standard"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-2">
                    <label class="m-0" for="campus">Faculty </label>
                    <div v-if="this.form.id == 0">
                        <div v-if="facultyLoading">
                            <div class="d-flex justify-content-center m-3">
                                <i class="bx bx-loader font-size-30"></i>
                            </div>
                        </div>
                        <div v-if="!facultyLoading">
                            <div
                                class="
                                    cursor-pointer
                                    py-3
                                    px-2
                                    br-5
                                    border-dashed-1
                                    position-relative
                                "
                                style="min-height: 50px"
                                v-if="!facultySelection"
                            >
                                <div
                                    class="
                                        position-absolute
                                        w-100
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                    style="top: 0; left: 0; bottom: 0; right: 0"
                                    @click="openFacultySelection"
                                >
                                    <h5
                                        class="mb-0 text-muted text-center"
                                        v-if="selectedFaculty.length == 0"
                                    >
                                        Click to Select Faculties
                                    </h5>
                                </div>
                                <div
                                    class="w-100"
                                    style="
                                        top: 10px;
                                        left: 10px;
                                        bottom: 10px;
                                        right: 10px;
                                    "
                                    v-if="selectedFaculty.length > 0"
                                >
                                    <div class="multiselect__tags-wrap">
                                        <span
                                            class="multiselect__tag"
                                            v-for="(du, index) in selectedFaculty"
                                            :key="du.id"
                                        >
                                            <span>{{ du.fullName }}</span>
                                            <i
                                                class="multiselect__tag-icon"
                                                @click="removeFaculty(index)"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="py-3 br-5 border-dashed-1 position-relative"
                            v-if="facultySelection"
                            v-click-outside="closeFaculty"
                        >
                            <div class="px-2">
                                <div class="multiselect__tags-wrap">
                                    <span
                                        class="multiselect__tag"
                                        v-for="(fac, index) in selectedFaculty"
                                        :key="fac.id"
                                    >
                                        <span>{{ fac.fullName }}</span>
                                        <i
                                            class="multiselect__tag-icon"
                                            @click="removeFaculty(index)"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="custom-inline-form w-100 text-center"
                                placeholder="Search Faculty"
                                @click="openFaculty = true"
                                v-model="filterFaculty"
                                ref="inputFaculty"
                            />
                            <div
                                class="
                                    selection-wrapper
                                    position-absolute
                                    w-100
                                "
                                v-if="openFaculty"
                            >
                                <ul class="multiselect__content text-left">
                                    <template v-if="available.length == 0">
                                        <li>
                                            <span class="multiselect__option"
                                                >No data found</span
                                            >
                                        </li>
                                    </template>
                                    <template
                                        v-if="
                                            available.length > 0 &&
                                            filteredFaculties.length == 0
                                        "
                                    >
                                        <li>
                                            <span class="multiselect__option"
                                                >Search not found</span
                                            >
                                        </li>
                                    </template>
                                    <li
                                        class="multiselect__element"
                                        v-for="x in filteredFaculties"
                                        :key="x.id"
                                        @click="selectFacultyFL(x)"
                                    >
                                        <span class="multiselect__option">{{
                                            x.fullName
                                        }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <input
                        class="form-control"
                        v-model="form.fullName"
                        disabled
                        v-if="form.id > 0"
                    />
                    <div
                        v-if="submitted && faculty.length == 0"
                        class="invalid-feedback"
                    >
                        <span>This value is required.</span>
                    </div>
                </div>
                <div class="mb-2">
                    <label class="m-0" for="campus">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
                    <multiselect
                        v-model="campus"
                        :options="campuses"
                        label="CampusName"
                        @select="selectCampus"
                        track-by="Id"
                        value="Id"
                        deselect-label=""
                        select-label=""
                        :allow-empty="false"
                    />
                </div>
                <div class="mb-2">
                    <label class="m-0" for="campus">Delivery Unit </label>
                    <span v-if="duLoading">Loading...</span>
                    <multiselect
                        v-if="!duLoading"
                        v-model="deliveryUnit"
                        :options="dus"
                        label="name"
                        @select="selectDU"
                        track-by="id"
                        value="id"
                        deselect-label=""
                        select-label=""
                        :allow-empty="false"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.deliveryUnitId.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.deliveryUnitId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.deliveryUnitId.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('modal-standard')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="card border">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <h4 class="card-title m-0 text-nowrap me-2">
                            Faculty List
                        </h4>
                    </div>
                    <div class="col-md-6 text-right">
                        <div class="d-flex align-items-center float-end">
                            <a
                                href="javascript:void(0);"
                                class="me-4 text-white"
                                @click="showFilter = !showFilter"
                                id="filter-faculty"
                                ><b class="d-flex align-items-center"
                                    ><i class="bx bx-filter font-size-18"></i
                                    >Show Filters</b
                                ></a
                            >
                            <b-popover
                                :target="`filter-faculty`"
                                triggers="click blur"
                                placement="left"
                                :show.sync="showFilter"
                                custom-class="popover-supplier"
                            >
                                <template v-slot:title>
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-between
                                        "
                                    >
                                        <small>Filters</small>
                                        <span
                                            class="
                                                bx bx-x
                                                font-size-14
                                                cursor-pointer
                                            "
                                            @click="showFilter = false"
                                        ></span>
                                    </div>
                                </template>
                                <div class="mb-2">
                                    <label for="campusSelect"
                                        >Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</label
                                    >
                                    <b-form-select
                                        id="campusSelect"
                                        class="form-select"
                                        v-model="campusSelect"
                                        size="sm"
                                        @change="filteredDU"
                                    >
                                        <option value="0">All</option>
                                        <option
                                            v-for="x in campuses"
                                            :key="x.Id"
                                            :value="x.Id"
                                        >
                                            {{ x.CampusName }}
                                        </option>
                                    </b-form-select>
                                </div>
                                <div class="mb-2" v-if="campusSelect > 0">
                                    <label for="duSelect"
                                        >Select Delivery Unit</label
                                    >
                                    <b-form-select
                                        id="duSelect"
                                        class="form-select"
                                        v-model="duSelect"
                                        size="sm"
                                        @change="searchFaculty"
                                    >
                                        <option
                                            v-for="x in dus"
                                            :key="x.id"
                                            :value="x.id"
                                        >
                                            {{ x.name }}
                                        </option>
                                    </b-form-select>
                                </div>
                            </b-popover>
                            <button
                                type="button"
                                @click="addFaculty"
                                class="btn btn-info d-flex align-items-center"
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_length"
                            class="dataTables_length"
                        >
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                    class="form-select form-select-sm"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search..."
                                    class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="tableData"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :busy="tableBusy"
                        @filtered="onFiltered"
                        bordered
                        outlined
                        hover
                        striped
                        show-empty
                    >
                        <template #empty="scope">
                            <div class="text-center">
                                {{ scope.emptyText }}
                            </div>
                        </template>
                        <template #table-busy>
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template #cell(faculty)="row">
                            <div class="d-flex align-items-center">
                                <div class="avatar-sm me-2">
                                    <span
                                        class="
                                            avatar-title
                                            rounded-circle
                                            bg-soft bg-primary
                                            text-primary
                                            font-size-16
                                        "
                                        >{{
                                            row.item.accountableOfficer.firstName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}{{
                                            row.item.accountableOfficer.lastName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}</span
                                    >
                                </div>
                                <div>
                                    <div class="mt-1">
                                        <h5 class="mb-0">
                                            {{
                                                row.item.accountableOfficer.lastName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.lastName.slice(
                                                    1
                                                )
                                            }},
                                            {{
                                                row.item.accountableOfficer.firstName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.firstName.slice(
                                                    1
                                                )
                                            }}
                                            {{
                                                row.item.accountableOfficer
                                                    .middleName
                                                    ? `${row.item.accountableOfficer.middleName
                                                          .charAt(0)
                                                          .toUpperCase()}.`
                                                    : ""
                                            }}
                                        </h5>
                                    </div>
                                    <div>
                                        {{
                                            row.item.accountableOfficer.position
                                        }}
                                    </div>
                                    <i>{{
                                        row.item.accountableOfficer.idNo
                                    }}</i>
                                </div>
                            </div>
                        </template>
                        <template #cell(designation)="row">
                            <div>
                                <b class="text-white">{{
                                    row.item.accountableOfficer.campus
                                }}</b>
                                <ul class="m-0 ps-4">
                                    <li>
                                        {{ row.item.deliveryUnit.name }}
                                    </li>
                                </ul>
                            </div>
                        </template>
                        <template #cell(engagement)="row">{{row.value ? row.value : 'Not assigned yet.'}}</template>
                        <template #cell(actions)="row">
                            <div class="float-end">
                                <b-dropdown
                                    id="dropdown-dropleft"
                                    right
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    menu-class="dropdown-menu-end"
                                    no-caret
                                >
                                    <template #button-content>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="updateItem(row)"
                                        variant="dark"
                                        ><i
                                            class="bx bx-edit font-size-18 me-1"
                                        ></i
                                        >Edit</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        @click="deleteItem(row)"
                                        variant="danger"
                                        ><i
                                            class="
                                                mdi mdi-trash-can
                                                font-size-18
                                                me-1
                                            "
                                        ></i
                                        >Delete</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>